import {Link, useNavigate} from "react-router-dom";
import {markQuestion} from "../variables/PracticePageFilter";
import Icon from "../../../../components/Icon/Icon";
import {useSession} from "../../../../redux/Reducers/AuthReducer";


function LoadingRow({className}) {

    return (
        <div
            className={`bg-gray-200 opacity-60 animate animate-pulse  cursor-pointer flex flex-col flex-wrap lg:flex-row gap-2 justify-start items-start rounded-md w-full py-3 px-4 border-l-[3px] border-gray-300  ${className}`}>
            <div
                className={"font-bold w-1/2 py-3 opacity-50 bg-gray-300 rounded-full whitespace-nowrap text-sm lg:text-xl"}/>
            <div className={"flex-1"}></div>
            <div
                className={"font-bold w-1/4 py-3  opacity-50 bg-gray-300 rounded-full whitespace-nowrap text-sm lg:text-xl"}/>
        </div>
    )
}


const QuestionRow = ({className, id, practiced, tested, to, title, metaData, ...props}) => {
    const navigate = useNavigate();
    const {session, authActions} = useSession();

    function Star() {
        let marker = metaData?.marker
        if (!marker)
            return <Icon name={"star"} className={"w-6 h-6"} alt={"Star"}/>
        let options = markQuestion.options;
        let star = options.find((option) => option.value === marker?.marker)?.name;
        return star;
    }

    return (
        <div
            onClick={() => {
                if (authActions.hasActiveSubscription() || authActions.hasDailyLimit()) {
                    navigate(to)
                    return;
                }
                authActions.showSubscriptionModal();

            }}
            className={`bg-tertiary-150 cursor-pointer flex flex-col  md:flex-row gap-4 justify-center items-center rounded-md w-full py-3 px-4 border-l-[3px] border-tertiary-900  ${className}`}>
            <p className={"font-bold flex-1   text-sm lg:text-xl"}>
                #{id ? id : "-"}{" "}{title ? title : "TITLE HERE"}
            </p>
            <div className={"flex  gap-4 flex-row"}>
                {
                    props?.difficulty &&
                    <p className={"rounded-md text-secondary-900 text-xs whitespace-nowrap lg:text-sm font-semibold  p-1 border-[1px] border-secondary-900"}>
                        {props.difficulty === "easy" ? "Easy ≤95" : ""}
                        {props.difficulty === "medium" ? "Medium 100-125" : ""}
                        {props.difficulty === "hard" ? "Hard ≥130" : ""}
                    </p>
                }
                {

                    <p className={"rounded-md text-xs lg:text-sm font-semibold text-gray-400 p-1 border-[1px] border-gray-300"}>
                        {metaData?.practiced?.lastPracticed ? "Practiced" : "Not Practiced"}
                    </p>
                }

                <div className={"flex  gap-2 md:gap-4  justify-center items-center flex-row"}>
                    <p className={"font-semibold whitespace-nowrap text-sm md:text-lg text-tertiary-900 "}>
                        Tested x {tested ? tested : 0}
                    </p>
                    {
                        Star()
                    }
                </div>
            </div>


        </div>

    )
}
QuestionRow.Loading = LoadingRow;

export default QuestionRow;